import { render, staticRenderFns } from "./MediaSetting.vue?vue&type=template&id=2629f037&"
import script from "./MediaSetting.vue?vue&type=script&lang=js&"
export * from "./MediaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2629f037')) {
      api.createRecord('2629f037', component.options)
    } else {
      api.reload('2629f037', component.options)
    }
    module.hot.accept("./MediaSetting.vue?vue&type=template&id=2629f037&", function () {
      api.rerender('2629f037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/MediaSetting.vue"
export default component.exports